import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function ApproveShiftsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;

    const load = async () => {
      try {
        setLoading(true);
        const res = await fetch(`/api/shifts/pending?firma=${user.firma}`, {
          credentials: "include",
        });
        const data = await res.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("ApproveShiftsPage load error:", e);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [user]);

  const openPlan = (p) => {
    // Otevře ShiftsPage v review režimu pro konkrétní pobočku/měsíc
    const base = user?.role === "admin" ? "/admin/shifts" : "/shifts";

    navigate(
      `${base}?mode=review&pharmacy=${encodeURIComponent(
        p.pharmacyCode
      )}&year=${p.year}&month=${p.month}`
    );
  };


  if (loading) return <div className="p-6">Načítám pending plány…</div>;

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Schvalování směn</h1>

      {items.length === 0 ? (
        <div className="text-gray-600">
          Žádné plány ve stavu <span className="font-semibold">pending</span>.
        </div>
      ) : (
        <div className="border rounded-xl overflow-hidden bg-white shadow-sm">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-3 border-b">Pobočka</th>
                <th className="text-left p-3 border-b">Měsíc</th>
                <th className="text-left p-3 border-b">Status</th>
                <th className="text-right p-3 border-b">Akce</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr
                  key={`${p.pharmacyCode}-${p.year}-${p.month}`}
                  className="hover:bg-gray-50"
                >
                  <td className="p-3 border-b font-semibold">{p.pharmacyCode}</td>
                  <td className="p-3 border-b">
                    {String(p.month).padStart(2, "0")}.{p.year}
                  </td>
                  <td className="p-3 border-b">
                    <span className="inline-flex px-2 py-1 rounded-full text-xs font-semibold bg-yellow-50 text-yellow-800 border border-yellow-200">
                      {p.status || "pending"}
                    </span>
                  </td>
                  <td className="p-3 border-b text-right">
                    <button
                      onClick={() => openPlan(p)}
                      className="px-3 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                    >
                      Otevřít plán
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
